import { EsquireClient } from "@/types/clients/esquire";
import {UpdatePassportPayload} from "@/types/clients/esquire/payloads/update-passport-payload";

export default class PutPassportConfirmUpdate {
  constructor(private client: EsquireClient) {}

  public async send(passportId: number, updatePassport: UpdatePassportPayload): Promise<boolean> {
    const url = await this.client.fetchUrlFromSession("passport-confirm");

    const data = {
      passport_id: passportId,
      passport: updatePassport
    };

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );
    await this.client.logOutIfForbidden(response.status);

    return response.ok;
  }
}
